module.exports = "<div class=\"modal-header\">\r\n   <h4 translate>Success!</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n   <p class=\"p-3\"\r\n      translate>\r\n      Your Username was sent to your mobile phone via SMS\r\n   </p>\r\n</div>\r\n<div class=\"modal-footer\">\r\n   <rw-button action=\"$ctrl.confirm()\"\r\n              variant=\"contained\">\r\n      <translate>\r\n         OK\r\n      </translate>\r\n   </rw-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/components/forgot-username/views/forgot-username-modal.html
// module id = 1226
// module chunks = 0